import ReactGA4 from "react-ga4";
import { isDev } from "./Environment";

const g_TRACKING_ID = process.env.REACT_APP_GOOGLE_TRACKING_ID
const g_TRACKING_ID_DEV = process.env.REACT_APP_GOOGLE_TRACKING_ID_DEV


export const GoogleAnalyticsInitialize = () => {

    if (!isDev()) {
        ReactGA4.initialize(g_TRACKING_ID);
    } else {
        ReactGA4.initialize(g_TRACKING_ID_DEV);
    }

};

export const GoogleAnalyticsEvent = (event, category, label, data) => {

    try {
        // console.log("GA event:", event, ":", category, ":", label);

        // Send GA4 Event
        let event_params = {
            category: category,
            label: label,
            ...data
        };
        ReactGA4.event(event, event_params);
    } catch {

    }
};

export const GoogleAnalyticsUser = (uuid) => {
    ReactGA4.set({ userId: uuid });
}

